export function calculateAgeByDate(birthDate: Date) {
    const today = new Date();
    const ageDiff = today.getFullYear() - birthDate.getFullYear();
    const hasHadBirthdayThisYear =
        today.getMonth() > birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() &&
            today.getDate() >= birthDate.getDate());

    const age = hasHadBirthdayThisYear ? ageDiff : ageDiff - 1;

    return age;
}